import Icon from '../../common/components/Icon';
import React from 'react';

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, id }) => {
  return (
    <label className="ecom-checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} id={id} />
      <div className={`ecom-checkbox__box ${checked ? 'checked' : ''}`}>
        <Icon name="ecom-checkmark" size="small" />
      </div>
    </label>
  );
};

export default Checkbox;
